module.exports = __webpack_public_path__ + "static/media/voltar.5fc65882.svg";